// The performers a budget line item can be assigned to (O-4320): the offer's
// own artist plus any sibling-offer artists sharing the budget, deduped by id.
// Sourced from the offer/siblings rather than the calendar event because an
// offer isn't always linked to an event (then there is no event performer list).
export const collectOfferPerformers = (offer, eventOffers = []) => {
  const byId = new Map();
  const add = (performer) => {
    if (performer && performer.id != null && !byId.has(performer.id)) {
      byId.set(performer.id, performer);
    }
  };
  add(offer?.primary_performer);
  (eventOffers || []).forEach((sibling) => add(sibling?.primary_performer));
  return Array.from(byId.values());
};
